'use strict';
angular.module('singleConceptAuthoringApp.taskDetail', [])

  .controller('taskDetailCtrl', ['$rootScope', '$scope', '$routeParams', '$route', '$location', '$timeout', '$modal', 'metadataService', 'accountService', 'scaService', 'terminologyServerService', 'aagService', 'promotionService', 'crsService', 'notificationService', '$q', 'reviewService', 'rnmService', 'permissionService', 'modalService', 'componentAuthoringUtil',
    function taskDetailCtrl($rootScope, $scope, $routeParams, $route, $location, $timeout, $modal, metadataService, accountService, scaService, terminologyServerService, aagService, promotionService, crsService, notificationService, $q, reviewService, rnmService, permissionService, modalService, componentAuthoringUtil) {

      var externalAuthoringGroup = null;
      $scope.task = null;
      $scope.branch = metadataService.getBranch();
      $rootScope.branchLocked = false;
      $scope.crsConcepts = [];

      // the project and task branch objects
      $scope.projectBranch = null;
      $scope.promoting = false;
      $scope.automatePromotionStatus = "";
      $scope.automatePromotionErrorMsg = "";
      $scope.hasRequestPendingClarification = crsService.hasRequestPendingClarification;
      $scope.isTaskPromotionDisabled = metadataService.isTaskPromotionDisabled;
      $scope.sac = [];
      $scope.userRoles = [];
      $scope.complex = false;
      $scope.batch = false;
      $scope.sacSet = false;
      $scope.lineItems = [];
      $scope.globalLineItems = [];
      $scope.releaseNotesDisabled = true;
      $scope.releaseNotesCollapsed = false;

      $scope.isExternalAuthoringUser = function() {
        return (externalAuthoringGroup && $rootScope.accountDetails.roles.includes('ROLE_' + externalAuthoringGroup));
      }

      // set the parent concept for initial taxonomy load (null -> SNOMEDCT
      // root)
      $scope.taxonomyConcept = null;

      $scope.sacSignedOff = function () {
          let value = true;
          angular.forEach($scope.sac, function (criteria) {
              if (criteria.complete === false) {
                value = false;
              }
            });
          return value;
      }

      $scope.getPromoteDisabledReason = function () {        
        if (!$scope.task) {
          return 'Task data has not been loaded';
        }

        if ($scope.task.status === 'New') {
          return 'Task status is New';
        }
        if ($scope.task.latestClassificationJson && $scope.task.latestClassificationJson.status === 'RUNNING') {
          return 'Classification is currently running';
        }
        if ($scope.promoting) {
          return 'Promotion is in progress';
        }
        if ($scope.automatePromotionStatus === 'Queued') {
          return 'Automated promotion is queued';
        }
        if ($scope.isAutomatePromotionRunning && $scope.isAutomatePromotionRunning()) {
          return 'Automated promotion is in progress';
        }
        if ($scope.hasRequestPendingClarification && $scope.hasRequestPendingClarification()) {
          return 'The linked CRS request(s) are pending clarification';
        }
        if ($scope.isTaskPromotionDisabled && $scope.isTaskPromotionDisabled()) {
          return 'Task promotion is disabled for this project';
        }
        if (!$scope.sacSignedOff()) {
          return 'Not all Acceptance Criteria have been signed off';
        }
        if ($scope.branchLocked && $scope.task.status !== 'Promoted' && $scope.task.status !== 'Completed') {
          return 'Task branch is locked (rebase, promotion or classification in progress)';
        }
        return '';
      };

      $scope.markBranchAsComplex = function () {
        scaService.getTaskForProject($routeParams.projectKey, $routeParams.taskKey).then(function (response) {
          $scope.task = response;
          terminologyServerService.markBranchAsComplex($scope.branch, !$scope.complex).then(function (response) {
            var branchMetadata = metadataService.getBranchMetadata();
            if (!response.metadata) {
              delete branchMetadata.metadata;
            } else {
              branchMetadata.metadata = response.metadata;
            }
            metadataService.setBranchMetadata(branchMetadata);
            $scope.complex = metadataService.isComplex();
            aagService.getBranchSAC($scope.branch).then(function (sac) {
                $scope.sac = [];
                if (sac && sac.criteriaItems) {
                  angular.forEach(sac.criteriaItems, function (criteria) {
                    if (criteria.authoringLevel === "TASK") {
                      if ($scope.complex && criteria.id.includes('task-review-changes') && $scope.task.status === 'Review Completed' && !criteria.complete) {
                        aagService.acceptBranchSAC($scope.branch, criteria.id).then(function() {
                          criteria.complete = true;
                          $scope.sac.push(criteria);
                        }, function() {
                          $scope.sac.push(criteria);
                        });
                      } else {
                        $scope.sac.push(criteria);
                      }
                    }
                  });
                }
              });
          });
        });
      }

      rnmService.getBranchLineItems($scope.branch).then(function (lineItems) {
          if (lineItems) {
            angular.forEach(lineItems, function (item) {
                $scope.lineItems.push(item);
            });
            if($scope.lineItems.length === 1){
                $scope.lineItem = $scope.lineItems[0];
            }
          }
      });

      rnmService.getBranchLineItems('MAIN').then(function (lineItems) {
          if (lineItems) {
            angular.forEach(lineItems, function (item) {
                $scope.globalLineItems.push(item);
            });
          }
      });

      $scope.openLineItemModal = function (id) {
          let item = {};
          let globalItems = [];
          let readOnly = false;
          if(!$scope.userRoles.includes('AUTHOR') || $scope.role !== 'AUTHOR') {
             readOnly = true;
          }
          angular.forEach($scope.lineItems, function (lineItem) {
            if (lineItem.id === id) {
              item = lineItem;
            }
          });
          angular.forEach($scope.globalLineItems, function (lineItem) {
            if(lineItem.title === "Content Development Activity"){
                angular.forEach(lineItem.children, function (child) {
                  if ($scope.lineItems.filter(function(item) {return item.title === child.title}).length == 0) {
                    globalItems.push(child);
                  }
                });
            }
          });
          let mode;
          if (readOnly) {
            mode = 'READ_ONLY';
          } else {
            if (item.id) {
              mode = 'EDIT';
            } else {
              mode = 'NEW';
            }
          }

          var modalInstance = $modal.open({
            templateUrl: 'shared/releaseNotes/lineItem.html',
            controller: 'lineItemCtrl',
            backdrop: readOnly ? '' : 'static',
            keyboard: readOnly ? true: false,
            resolve: {
                branch: function() {
                  return $scope.branch;
                },
                lineItem: function() {
                  return item;
                },
                lineItems: function() {
                  return $scope.lineItems;
                },
                globalLineItems: function() {
                  return globalItems;
                },
                mode: function() {
                  return mode;
                },
                isProject: function() {
                  return false;
                }
              }
          });

          modalInstance.result.then(function () {
              rnmService.getBranchLineItems($scope.branch).then(function (lineItems) {
                  if (lineItems && lineItems.length > 0) {
                    $scope.lineItems = [];
                    angular.forEach(lineItems, function (item) {
                        $scope.lineItems.push(item);
                    });
                    if($scope.lineItems.length === 1){
                        $scope.lineItem = $scope.lineItems[0];
                    }
                  }
                  else{
                      $scope.lineItems = [];
                      delete $scope.lineItem;
                  }
              });
          });
      };

      $scope.acceptManualSac = function (id) {
          aagService.acceptBranchSAC($scope.branch, id).then(function (sac) {
              aagService.getBranchSAC($scope.branch).then(function (sac) {
                  $scope.sac = [];
                  if (sac && sac.criteriaItems) {
                    angular.forEach(sac.criteriaItems, function (criteria) {
                      if (criteria.authoringLevel === "TASK") {
                        $scope.sac.push(criteria);
                      }
                    });
                  }
              });
          });
      };

      $scope.unacceptManualSac = function (id) {
          aagService.unacceptBranchSAC($scope.branch, id).then(function (sac) {
              aagService.getBranchSAC($scope.branch).then(function (sac) {
                  $scope.sac = [];
                  if (sac && sac.criteriaItems) {
                    angular.forEach(sac.criteriaItems, function (criteria) {
                      if (criteria.authoringLevel === "TASK") {
                        $scope.sac.push(criteria);
                      }
                    });
                  }
              });
          });
      };

      $scope.classify = function () {
        // Capture identity at click time — $routeParams is mutated in place on route change
        var projectKey = $routeParams.projectKey;
        var taskKey = $routeParams.taskKey;

        componentAuthoringUtil.hasUnsavedConcepts($scope.task.projectKey, $scope.task.key).then(function(hasUnsavedConcepts) {
          if (hasUnsavedConcepts) {
            var message = 'There are unsaved changes. Would you like to save before proceeding with the classification?';
            modalService.confirm(message, 'width: 120%;').then(function () {
              notificationService.sendMessage('Starting classification for task ' + taskKey);
              if ($scope.task && $scope.task.status && $scope.task.status === 'New') {
                scaService.updateTask(projectKey, taskKey, {'status': 'IN_PROGRESS'}).then(function (response) {
                  doClassify(projectKey, taskKey);
                });
              } else {
                doClassify(projectKey, taskKey);
              }
            }, function() {
              setTimeout(function(){
                angular.element(document.activeElement).trigger('blur');
              });
            });
          } else {
            notificationService.sendMessage('Starting classification for task ' + taskKey);
            if ($scope.task && $scope.task.status && $scope.task.status === 'New') {
              scaService.updateTask(projectKey, taskKey, {'status': 'IN_PROGRESS'}).then(function (response) {
                doClassify(projectKey, taskKey);
              });
            } else {
              doClassify(projectKey, taskKey);
            }
          }
        });
      };

      function doClassify(projectKey, taskKey) {
        // start the classification
        scaService.startClassificationForTask(projectKey, taskKey).then(function (response) {

          if (!response || !response.data || !response.data.id) {
            notificationService.sendError('Error starting classification');
            return;
          }

          if (response.data.status) {
            notificationService.sendMessage('Classification is ' + response.data.status, 10000);
          } else {
            notificationService.sendMessage('Task submitted for classification', 10000);
          }

          $rootScope.$broadcast('reloadTask');


        }, function () {
          // do nothing on error
        });
      }

      $scope.promote = function () {
        if ($scope.isTaskPromotionDisabled()) {
          return;
        }

        // Capture identity at click time — $routeParams is mutated in place on route change
        var projectKey = $routeParams.projectKey;
        var taskKey = $routeParams.taskKey;

        $scope.promoting = true;
        notificationService.sendMessage('Preparing for task promotion...');

        promotionService.checkPrerequisitesForTask(projectKey, taskKey).then(function (flags) {

          // detect whether any user warnings were detected
          var warningsFound = false;
          angular.forEach(flags, function (flag) {
            if (flag.checkWarning) {
              warningsFound = true;
            }
          });

          // if response contains no flags, simply promote
          if (!warningsFound) {
            $rootScope.branchLocked = true;
            notificationService.sendMessage('Promoting task...');
            promotionService.promoteTask(projectKey, taskKey).then(function (response) {
              if (response.status === 'CONFLICTS') {
                var merge = JSON.parse(response.message);
                terminologyServerService.fetchConflictMessage(merge).then(function(conflictMessage) {
                  notificationService.sendError(conflictMessage);
                  $scope.branchLocked = false;
                  $scope.promoting = false;
                });
              }
            }, function (error) {
              $scope.promoting = false;
              $rootScope.branchLocked = false;
              notificationService.sendError('Error promoting task to project: ' + error);
            });
          } else {

            // clear the preparation notification
            notificationService.clear();
            var modalInstance = $modal.open({
              templateUrl: 'shared/promote-modal/promoteModal.html',
              controller: 'promoteModalCtrl',
              resolve: {
                flags: function () {
                  return flags;
                },
                isTask: function () {
                  return true;
                }
              }
            });

            modalInstance.result.then(function (proceed) {
              if (proceed) {
                $rootScope.branchLocked = true;
                notificationService.sendMessage('Promoting task...');
                promotionService.promoteTask(projectKey, taskKey).then(function (response) {
                  if (response.status === 'CONFLICTS') {
                    var merge = JSON.parse(response.message);
                    terminologyServerService.fetchConflictMessage(merge).then(function(conflictMessage) {
                      notificationService.sendError(conflictMessage);
                      $scope.branchLocked = false;
                      $scope.promoting = false;
                    });
                  }
                }, function (error) {
                  $scope.promoting = false;
                  $rootScope.branchLocked = false;
                  notificationService.sendError('Error promoting task to project: ' + error);
                });
              } else {
                notificationService.clear();
                $scope.promoting = false;
                $rootScope.branchLocked = false;
              }
            }, function () {
              notificationService.clear();
              $scope.promoting = false;
              $rootScope.branchLocked = false;
            });
          }
        }, function (error) {
          notificationService.sendError('Unexpected error preparing for promotion: ' + error);
          $scope.promoting = false;
          $rootScope.branchLocked = false;
        });
      };

      $scope.proceedAutomatePromotion = function () {
        if ($scope.isTaskPromotionDisabled()) {
          return;
        }

        // Capture identity at click time — $routeParams is mutated in place on route change
        var projectKey = $routeParams.projectKey;
        var taskKey = $routeParams.taskKey;

        notificationService.sendMessage('Preparing for task promotion automation...');
        $scope.automatePromotionErrorMsg = '';
        $scope.automatePromotionStatus = '';

        promotionService.checkPrerequisitesForAutomatedPromotionTask(projectKey, taskKey).then(function (flags) {

          // detect whether any user warnings were detected
          var warningsFound = false;
          angular.forEach(flags, function (flag) {
            if (flag.checkWarning) {
              warningsFound = true;
            }
          });

          // if response contains no flags, simply promote
          if (!warningsFound) {
            promoteTaskAutomation(projectKey, taskKey);
          } else {
            var modalInstance = $modal.open({
              templateUrl: 'shared/promote-modal/promoteModal.html',
              controller: 'promoteModalCtrl',
              resolve: {
                flags: function () {
                  return flags;
                },
                isTask: function () {
                  return true;
                }
              }
            });
            notificationService.clear();
            modalInstance.result.then(function (proceed) {
              if (proceed) {
                promoteTaskAutomation(projectKey, taskKey);
              } else {
                notificationService.clear();
              }
            }, function () {
              notificationService.clear();
              setTimeout(function(){
                angular.element(document.activeElement).trigger('blur');
              });
            });
          }
        }, function (error) {
          notificationService.sendError('Unexpected error preparing for promotion: ' + error);
          $scope.promoting = false;
        });
      };

      function promoteTaskAutomation(projectKey, taskKey) {
        notificationService.sendMessage('Starting automated promotion...');
        promotionService.proceedAutomatePromotion(projectKey, taskKey).then(function (response) {
            checkAutoPromotionStatus(false);
          }, function (error) {
            $scope.automatePromotionStatus = '';
          }
        );
      }

      $scope.startValidation = function () {
        if ($scope.task.status === 'Promoted' || $scope.task.status === 'Completed') {
          return;
        }

        // Capture identity at click time — $routeParams is mutated in place on route change
        var projectKey = $routeParams.projectKey;
        var taskKey = $routeParams.taskKey;

        checkPrerequisitesForValidation(projectKey, taskKey).then(function(message) {
          if (message) {
            modalService.confirm(message, 'white-space: pre-line;').then(function () {
              markTaskInProgressIfAnyAndValidate(projectKey, taskKey);
            }, function() {
              setTimeout(function(){
                angular.element(document.activeElement).trigger('blur');
              });
            });
          } else {
            markTaskInProgressIfAnyAndValidate(projectKey, taskKey);
          }
        });
      };

      function markTaskInProgressIfAnyAndValidate(projectKey, taskKey) {
        if ($scope.task.status === 'New') {
          scaService.updateTask(projectKey, taskKey, {'status': 'IN_PROGRESS'}).then(function (response) {
            doValidate(projectKey, taskKey);
          });
        } else {
          doValidate(projectKey, taskKey);
        }
      }

      function checkPrerequisitesForValidation(projectKey, taskKey) {
        var deferred = $q.defer();
        scaService.getTaskForProject(projectKey, taskKey).then(function (response) {
          let msg = null;
          let canConflict = false;
          if (response.branchState &&
              (response.branchState === 'BEHIND' || response.branchState === 'DIVERGED' || response.branchState === 'STALE')
              && $scope.task.status !== 'Promoted' && $scope.task.status !== 'Completed') {
              canConflict = true;
          }
          if (response.latestClassificationJson) {
            let latestClassificationJson = response.latestClassificationJson;
            if (latestClassificationJson.status === 'SAVED' && (new Date(response.branchHeadTimestamp)).getTime() - (new Date(latestClassificationJson.saveDate)).getTime() < 1000) {
              msg = null;
            } else if ((new Date(latestClassificationJson.creationDate)).getTime() < response.branchHeadTimestamp) {
              msg = canConflict ? 'The task has not been rebased. \n\nThere are new changes on this task since the last classification. \n\nDo you still want to start a validation?' :
                                  'There are new changes on this task since the last classification. Do you still want to start a validation?';
            } else {
              if ((latestClassificationJson.inferredRelationshipChangesFound || latestClassificationJson.equivalentConceptsFound)
                && latestClassificationJson.status !== 'SAVED') {
                msg = canConflict ? 'The task has not been rebased. \n\nClassification has been run, but the results have not been saved. \n\nDo you still want to start a validation?' :
                                    'Classification has been run, but the results have not been saved. Do you still want to start a validation?'
              }
            }
          } else {
            msg = canConflict ? 'The task has not been rebased. \n\nClassification has not been run. \n\nDo you still want to start a validation?' :
                                'Classification has not been run. Do you still want to start a validation?';
          }
          if (!msg && canConflict) {
            msg = 'Task has not been rebased. Do you still want to start a validation?';
          }

          deferred.resolve(msg);
        });
        return deferred.promise;
      }

      function doValidate(projectKey, taskKey) {
        // NOTE: Validation does not lock task
        notificationService.sendMessage('Submitting task for validation...');

        scaService.startValidationForTask(projectKey, taskKey, $scope.enableMRCMValidation).then(function (response) {
          $rootScope.$broadcast('reloadTask');
          notificationService.sendMessage('Task successfully submitted for validation', 3000, null);
        }, function (error) {
          notificationService.sendError('Error submitting task for validation: ' + error);
          $rootScope.$broadcast('reloadTask');
        });
      }

      // list of tracked unsaved concepts
      $scope.reviewChecks = null;

      $scope.cancelSubmitForReview = function () {
        $scope.reviewChecks = null;
      };

      function openReviewChecksModal(reviewChecks) {

        // check if unsaved concepts are already in edit panel
        angular.forEach(reviewChecks.unsavedConcepts, function (uc) {
          angular.forEach($scope.editList, function (ec) {
            if (ec === uc.conceptId) {
              uc.editing = true;
            }
          });
        });

        var deferred = $q.defer();
        var modalInstance = $modal.open({
          templateUrl: 'shared/review-check-modal/reviewCheckModal.html',
          controller: 'reviewCheckModalCtrl',
          resolve: {
            reviewChecks: function() {
              return reviewChecks;
            }
          }
        });

        modalInstance.result.then(function (results) {
          deferred.resolve(results);
        }, function () {
          deferred.reject();
        });
        return deferred.promise;

      }

      $scope.toggleReview = function (ignoreWarnings) {
        $scope.reviewChecks = null;
        switch ($scope.task.status) {
          case 'New':
          case 'In Progress':

            notificationService.sendMessage('Submit for review requested: checking content changes...');

            reviewService.checkReviewPrerequisites($scope.task).then(function (reviewChecks) {

              if (reviewChecks.hasChangedContent && reviewChecks.unsavedConcepts && reviewChecks.unsavedConcepts.length === 0 && reviewChecks.classificationStatuses.length === 0 && reviewChecks.unsavedCrsRequests.length === 0) {
                reviewService.submitForReview($scope.task).then(function () {
                  notificationService.sendMessage('Submitted for review', 3000);
                }, function (error) {
                  notificationService.sendError('Error submitting for review: ' + error);
                });
              } else {
                openReviewChecksModal(reviewChecks).then(function () {
                  reviewService.submitForReview($scope.task).then(function () {
                    notificationService.sendMessage('Submitted for review', 3000);
                  }, function (error) {
                    notificationService.sendError('Error submitting for review: ' + error);
                  });
                }, function () {
                  notificationService.sendMessage('Cancelled submit for review', 3000);
                });
              }
            }, function (error) {
              notificationService.sendWarning('Task submitted for review, but could not verify content changes: ' + error);
            });


            break;
          case 'Ready For Review':
          case 'In Review':
          case 'Review Complete':
            accountService.getRoleForTask($scope.task).then(function (role) {
              if (role === 'AUTHOR') {
                scaService.getUiStateForReviewTask($routeParams.projectKey, $routeParams.taskKey, 'reviewed-list').then(function (response) {
                  var reviewedListIds = response ?  (Array.isArray(response) ? response : response.conceptIds) : [];
                  if (reviewedListIds.length > 0) {
                    modalService.confirm('There are ' + reviewedListIds.length + ' approved concepts in the review. Cancelling will reset all concepts to unapproved and will require all concepts to be (re-)approved in a new review. To keep the approved work, please ask the reviewer to unclaim the review. Are you sure you want to cancel this review?', 'font-size: 14px;line-height: 1.7;').then(function () {
                      reviewService.cancelReview($scope.task).then(function () {
                        notificationService.sendMessage('Review Cancelled', 2000);
                      });
                    }, function () {
                      // do nothing
                    });
                  } else {
                    reviewService.cancelReview($scope.task).then(function () {
                      notificationService.sendMessage('Review Cancelled', 2000);
                    });
                  }
                }, function () {
                  modalService.confirm('Could not load the approved list. Cancelling may reset approved concepts and will require all concepts to be (re-)approved in a new review. To keep the approved work, please ask the reviewer to unclaim the review. Are you sure you want to cancel this review?', 'font-size: 14px;line-height: 1.7;').then(function () {
                    reviewService.cancelReview($scope.task).then(function () {
                      notificationService.sendMessage('Review Cancelled', 2000);
                    });
                  }, function () {
                    // do nothing
                  });
                });
              } else {
                reviewService.unclaimReview($scope.task).then(function () {
                  $location.url('review-tasks');
                  notificationService.sendMessage('Review unclaimed', 3000);
                }, function (error) {
                  notificationService.sendError('Error unclaiming review: ' + error);
                });
              }
            });
            break;
          default:
            notificationService.sendError('Unexpected task status: ' + $scope.task.status);
        }
      };

      $scope.updateTask = function () {
        var modalInstance = $modal.open({
          templateUrl: 'shared/task/task.html',
          controller: 'taskCtrl',
          resolve: {
            task: function () {
              return $scope.task;
            },
            canDelete: function () {
              return true;
            }
          }
        });

        modalInstance.result.then(function (response) {

          // check for task deletion
          if (response === 'DELETED') {
            $location.url('home');
          } else {
            let updatedTask = response.data;
            if ($scope.task.assignee.username !== updatedTask.assignee.username) {
              $route.reload();
              return;
            }

            $scope.task.summary = updatedTask.summary;
            $scope.task.description = updatedTask.description;

            // broadcast reload task event
            // NOTE:  Not necessary to broadcast as of 12/11, but in place in
            // case further task revision scenarios require app-wide reload
            // NOTE:  Also triggers up-to-date task reload here
            $rootScope.$broadcast('reloadTask');
          }
        }, function () {
        });
      };

      $scope.isAutomatePromotionRunning = function (){
        if($scope.automatePromotionStatus === 'Rebasing'
          || $scope.automatePromotionStatus === 'Classifying'
          || $scope.automatePromotionStatus === 'Promoting') {
          return true;
        }
        return false;
      };

      $scope.checkForLock = function () {
        checkAutoPromotionStatus(true).then(function () {
          checkBranchLock();
        });
      };

      function checkBranchLock() {
        terminologyServerService.getBranch($scope.branch).then(function (response) {

          // if lock found, set rootscope variable and continue polling
          if (response.locked) {
            $rootScope.branchLocked = true;
            $timeout(function () {
              // Stop checking for lock if the task key not found
              if ($routeParams.taskKey && $scope.branch.endsWith($routeParams.taskKey)) {
                checkBranchLock();
              }
            }, 10000);
           }
          else {
            $rootScope.classificationRunning = $scope.task.latestClassificationJson && ($scope.task.latestClassificationJson.status === 'RUNNING' || $scope.task.latestClassificationJson.status === 'SCHEDULED' || $scope.task.latestClassificationJson.status === 'BUILDING');
            $rootScope.branchLocked = $rootScope.classificationRunning;
          }
        });
      }

      function setPromotionFlags(automatedPromotionInQueued, branchLocked, classificationRunning) {
        $rootScope.automatedPromotionInQueued = automatedPromotionInQueued;
        $rootScope.branchLocked = branchLocked;
        $rootScope.classificationRunning = classificationRunning;
      }

      function handleQueuedStatus() {
        setPromotionFlags(true, false, false);
        notificationService.clear();
      }

      function handleRebasingStatus() {
        setPromotionFlags(false, true, false);
        notificationService.clear();
      }

      function handleRebasedWithConflictsStatus() {
        scaService.getTaskForProject($routeParams.projectKey, $routeParams.taskKey).then(function (taskResponse) {
          $scope.task = taskResponse;
          if ($scope.task.branchState !== 'FORWARD' && $scope.task.branchState !== 'UP_TO_DATE') {
            setPromotionFlags(false, false, false);
            $scope.automatePromotionErrorMsg = 'Merge conflicts detected during automated promotion. Please rebase task manually, resolve merge conflicts and then restart automation.';
          }
        });
      }

      function handleClassifyingStatus() {
        setPromotionFlags(false, true, true);
        notificationService.clear();
      }

      function handleClassificationInProgressStatus(isInitialCheck) {
        if (!isInitialCheck) {
          setPromotionFlags(false, true, true);
          $scope.automatePromotionErrorMsg = 'Error automate promotion: Classification already in progress on this branch.';
        }
        notificationService.clear();
        checkBranchLock();
      }

      function handleClassifiedStatus(response, isInitialCheck) {
        // Manual classification is running
        if (isInitialCheck && $rootScope.classificationRunning) {
          $scope.automatePromotionStatus = '';
          return;
        }

        setPromotionFlags(false, false, false);

        if (!isInitialCheck) {
          $rootScope.$broadcast('reloadTask');
          return;
        }

        var isClassificationSaved = $scope.task.latestClassificationJson.status === 'SAVED' ||
          new Date($scope.task.latestClassificationJson.completionDate) > new Date(response.completeDate);

        if (isClassificationSaved) {
          $scope.automatePromotionStatus = '';
        } else {
          if ($scope.automatePromotionStatus === 'Classified with results') {
            $scope.automatePromotionErrorMsg = 'Classification results detected during automated promotion. Please review and accept classification results, then restart automation.';
          } else {
            $scope.automatePromotionErrorMsg = 'Classification reports equivalent concepts on this branch. You may not promote until these are resolved.';
          }
        }
      }

      function handlePromotingStatus() {
        setPromotionFlags(false, true, false);
        notificationService.clear();
      }

      function handleFailedStatus(response, isInitialCheck) {
        setPromotionFlags(false, false, false);
        if (!isInitialCheck) {
          var errorMessage = 'Error automate promotion';
          if (typeof response.message !== 'undefined') {
            errorMessage += ': ' + response.message;
          }
          $scope.automatePromotionErrorMsg = errorMessage;
          notificationService.clear();
        } else {
          checkBranchLock();
        }
      }

      function handleDefaultStatus() {
        setPromotionFlags(false, false, false);
      }

      function shouldContinuePolling(status) {
        var pollingStatuses = ['Queued', 'Rebasing', 'Classifying', 'Promoting'];
        return pollingStatuses.indexOf(status) !== -1;
      }

      function checkAutoPromotionStatus(isInitialCheck) {
        var deferred = $q.defer();
        $scope.automatePromotionErrorMsg = '';

        if ($scope.task.status === 'Promoted' || $scope.task.status === 'Completed') {
          $scope.automatePromotionStatus = '';
          deferred.resolve();
          return deferred.promise;
        }

        promotionService.getAutomatePromotionStatus($routeParams.projectKey, $routeParams.taskKey).then(function (response) {
          if (!response || !response.status) {
            $scope.automatePromotionStatus = '';
            deferred.resolve(null);
            return;
          }

          $scope.automatePromotionStatus = response.status;
          var status = response.status;

          // Handle status-specific logic
          switch (status) {
            case 'Queued':
              handleQueuedStatus();
              break;
            case 'Rebasing':
              handleRebasingStatus();
              break;
            case 'Rebased with conflicts':
              handleRebasedWithConflictsStatus();
              break;
            case 'Classifying':
              handleClassifyingStatus();
              break;
            case 'Classification in progress':
              handleClassificationInProgressStatus(isInitialCheck);
              break;
            case 'Classified with results':
            case 'Classified with equivalencies Found':
              handleClassifiedStatus(response, isInitialCheck);
              break;
            case 'Promoting':
              handlePromotingStatus();
              break;
            case 'Completed':
              // No action needed
              break;
            case 'Failed':
              handleFailedStatus(response, isInitialCheck);
              break;
            default:
              handleDefaultStatus();
          }

          // Continue polling for active statuses
          if (shouldContinuePolling(status)) {
            $timeout(function () {
              checkAutoPromotionStatus(false);
            }, 10000);
          } else {
            deferred.resolve(status);
          }
        }, function (error) {
          deferred.resolve();
        });

        return deferred.promise;
      }

      $scope.viewConflicts = function () {
        terminologyServerService.getBranch(metadataService.getBranchRoot() + '/' + $routeParams.projectKey).then(function (response) {
          if (!response.locked) {
            $location.url('tasks/task/' + $routeParams.projectKey + '/' + $routeParams.taskKey + '/conflicts');
          }
          else {
            notificationService.sendWarning('Unable to start rebase on task ' + $routeParams.taskKey + ' as the project branch is locked due to ongoing changes.', 7000);
          }
        });
      };

      $scope.viewClassification = function () {
        $rootScope.$broadcast('viewClassification');
      };

      //
      // Issue Links
      //

      $scope.issueLinkFilter = function (issue) {

        // only return issues on the allowed projects (currently only CRT)
        // NOTE: Used project key as more stable than project name (SCT Content Request Ticket)
        // TODO Consider moving this to config file
        return issue && issue.outwardIssue && issue.outwardIssue.key && issue.outwardIssue.key.startsWith('CRT');
      };

      $scope.gotoLinkedIssue = function (issue) {
        // TODO Make this configurable?
        var issueKey = issue.outwardIssue.key;
        var rootUrl = /^(https:\/\/[^\/]*).*$/.exec(issue.outwardIssue.self);

        window.open(rootUrl[1] + '/browse/' + issueKey, issueKey);
      };

      $scope.userHasRole = function(requiredRoles) {
        return !requiredRoles || $scope.userRoles.filter(function(role) { return requiredRoles.indexOf(role) !== -1;}).length !== 0;
      };

      $scope.pollForCompletion = function () {
          scaService.getTaskForProject($routeParams.projectKey, $routeParams.taskKey).then(function (response) {
              // Poll if still running
              if (response.summary.includes('- Running')) {
                  $timeout(function () {
                      $scope.pollForCompletion();
                    }, 10000);
              }
              else{
                $scope.task = response;
              }
          });
      }

      function filterDuplicatedCRSRequests() {
        if ($scope.crsConcepts.length !== 0) {
          $scope.crsConcepts = $scope.crsConcepts.filter((value, index, self) =>
            index === self.findIndex((t) => (
              t.crsId === value.crsId
            ))
          );
        }
      }

      function getCRSRequests() {
        scaService.getCRSRequests($routeParams.projectKey, $routeParams.taskKey).then(function(response) {
          $scope.crsConcepts = response;
          filterDuplicatedCRSRequests();
        });
      }

      function findExternalAuthoringGroup() {
        var deferred = $q.defer();
        const allCodeSystems = metadataService.getCodeSystems();
        var foundCodeSystem = null;
        if (allCodeSystems && allCodeSystems.length !== 0) {
          for (let i = 0; i < allCodeSystems.length; i++) {
            if ($scope.task.branchPath.startsWith('MAIN/SNOMEDCT-')
                && allCodeSystems[i].branchPath.startsWith('MAIN/SNOMEDCT-')
                && $scope.task.branchPath.startsWith(allCodeSystems[i].branchPath)) {
              foundCodeSystem = allCodeSystems[i];
              break;
            }
          }
          if (!foundCodeSystem) {
            for (let i = 0; i < allCodeSystems.length; i++) {
              if (allCodeSystems[i].branchPath === 'MAIN') {
                foundCodeSystem = allCodeSystems[i];
                break;
              }
            }
          }

          if (foundCodeSystem) {
            terminologyServerService.getBranchMetadata(foundCodeSystem.branchPath, false).then(function (response) {
              if (response && response.externalAuthoringGroup) {
                deferred.resolve(response.externalAuthoringGroup);
              } else {
                deferred.resolve(null);
              }
            });
          } else {
            deferred.resolve(null);
          }
        }

        return deferred.promise;
      }

      function initialize() {

        // retrieve the task
        scaService.getTaskForProject($routeParams.projectKey, $routeParams.taskKey).then(function (response) {
          aagService.getBranchSAC(response.branchPath).then(function (sac) {
              $scope.sac = [];
              if (sac && sac.criteriaItems) {
                $scope.sacSet = true;
                angular.forEach(sac.criteriaItems, function (criteria) {
                  if (criteria.authoringLevel === "TASK") {
                    $scope.sac.push(criteria);
                  }
                });
              }
              else{
                $scope.sacSet = false;
              }
              $scope.complex = metadataService.isComplex();
              $scope.batch = metadataService.isBatch();
          });
          $scope.task = response;
          $scope.releaseNotesDisabled = metadataService.isExtensionSet();
          if($scope.task.summary.includes('- Running')){
              $scope.pollForCompletion();
          }
          if ($scope.task.status === 'Promoted' || $scope.task.status === 'Completed') {
            $rootScope.branchLocked = true;
          } else {
            $scope.checkForLock();
          }

          // get user roles from branch
          terminologyServerService.getBranch($scope.branch).then(function (response) {
            if (response.hasOwnProperty('userRoles')) {
              permissionService.setRolesForBranch($scope.branch, response.userRoles);
              $scope.userRoles = response.userRoles;
            } else {
              permissionService.setRolesForBranch($scope.branch, []);
            }
          });

          // get role for task: REVIEWER or AUTHOR or UNKNOWN
          accountService.getRoleForTask($scope.task).then(function (role) {
            $scope.role = role;
            if ($scope.role === 'AUTHOR') {
              // get extenal authoring group
              findExternalAuthoringGroup().then(function (response) {
                externalAuthoringGroup = response;
                if (externalAuthoringGroup && !metadataService.isComplex() && $rootScope.accountDetails.roles.includes('ROLE_' + externalAuthoringGroup)) {
                  $scope.complex = false;
                  $scope.markBranchAsComplex();
                }
              });
            }
          });

          // get latest rebase time
          terminologyServerService.getTraceabilityForBranch($scope.task.branchPath, null, 'REBASE').then(function(traceability) {
            if (traceability && !traceability.empty) {
              const content = traceability.content;
              let date = new Date(content[content.length - 1].commitDate);
              $scope.task.lastRebaseTime = date.toUTCString();
            }
          }, function () {
            // do nothing
          });

          if ($scope.task.branchState === 'DIVERGED') {
            $rootScope.$broadcast('branchDiverged');
          }

          if ($scope.task.labels && $scope.task.labels.indexOf('CRS') !== -1) {
            $scope.isCrsTask = true;
            $scope.crsConcepts = crsService.getAllCrsRequests();
            filterDuplicatedCRSRequests();
          } else {
            getCRSRequests();
          }
        });

        // Check MRCM validation for task
        scaService.getUiStateForTask($routeParams.projectKey, $routeParams.taskKey, 'task-mrcm-validation').then(function (response) {
          if (response !== null) {
            $scope.enableMRCMValidation = response.enableMRCMValidation;
          }
        });
      }

      $scope.$on('reloadCRSRequests', function (event, data) {
        getCRSRequests();
      });

      $scope.$on('initialiseCrsConceptsComplete', function (event, data) {
        $scope.crsConcepts = crsService.getAllCrsRequests();
        filterDuplicatedCRSRequests();
      });

      $scope.$on('reloadTask', function (event, data) {
        if (!data || (data && data.project === $routeParams.projectKey && data.task === $routeParams.taskKey)) {
          initialize();
        }
      });

      $scope.$on('promotion.completed', function (event, data) {
        if (data && data.project === $routeParams.projectKey && data.task === $routeParams.taskKey) {
            scaService.getProjectForKey($routeParams.projectKey).then(function (response) {
                if(response.metadata && response.metadata.internal && response.metadata.internal.integrityIssue) {
                    terminologyServerService.branchUpgradeIntegrityCheck(metadataService.getBranchRoot() + '/' + $routeParams.projectKey, 'MAIN/' + metadataService.getExtensionMetadata().codeSystemShortName).then( function(response) {
                        $rootScope.$broadcast('reloadTask');
                    });
                }
                else{
                    $rootScope.$broadcast('reloadTask');
                }
            });
        }
      });

// re-initialize if branch state changes
      $scope.$on('notification.branchState', function (event, data) {
        if (data.project === $routeParams.projectKey && data.task === $routeParams.taskKey) {
          initialize();
        }
      });

// reload SAC
    $scope.$on('reloadSAC', function (event, data) {
      if (data.task && data.task === $routeParams.taskKey && data.project === $routeParams.projectKey) {
        aagService.getBranchSAC($scope.branch).then(function (sac) {
          $scope.sac = [];
          if (sac && sac.criteriaItems) {
            angular.forEach(sac.criteriaItems, function (criteria) {
              if (criteria.authoringLevel === "TASK") {
                $scope.sac.push(criteria);
              }
            });
          }
        });
      }
    });

// re-initialize if concept change occurs and task is new
      $scope.$on('conceptEdit.conceptChange', function (event, data) {
        angular.forEach($scope.sac, function (criteria) {
          if (criteria.authoringLevel === "TASK" && criteria.id.includes('task-review-changes') && criteria.complete) {
            criteria.complete = false;
            aagService.unacceptBranchSAC($scope.branch, criteria.id).then(function() {
              console.log('Task review-changes has been updated to false');
            });
            return;
          }
        });

        initialize();
      });

      // $scope.$on('conceptEdit.conceptModified', function (event, data) {
      //   if ($scope.task.status === 'Review Completed') {
      //     scaService.updateTask($routeParams.projectKey, $routeParams.taskKey, {'status': 'IN_PROGRESS'}).then(function (response) {
      //       $scope.task = response;
      //     });
      //   }
      // });

      $scope.$on('triggerTaskValidation', function (event, data) {
        if (data.task && data.task === $routeParams.taskKey && data.project === $routeParams.projectKey) {
          $scope.startValidation();
        }
      });

      initialize();
    }

  ])
;
